var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{
    name: 'brand',
    params: { storeName: _vm.$store.storeName, id: _vm.id , name:this.name},
  }}},[_c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.image}})])]),_c('div',{staticClass:"product-name text-center"},[_c('p',[_vm._v(_vm._s(_vm.name))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }